// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AccountSidebarDrawer_wrap__nkCSJ","sidebarContainer":"AccountSidebarDrawer_sidebarContainer___xme6"};